module.exports = __webpack_public_path__ + "img/94.c3f7e935.jpg";